import { IAccountGuiModel } from "../model/IAccountGuiModel";
import AccountService from "../service/AccountService";
import { IAccountModel } from "../service/model/IAccountModel";
import { BusinessLogicResult } from "./BusinessLogicResult";

export default class AccountBusinessLogic {

    public async getAccounts(
        organizationId: string,
        accountType: "" | "GeneralLedger" | "Supplier" | "Customer" | "Other",
        freeText?: string,
        startRow?: number,
        pageSize?: number,
    ): Promise<BusinessLogicResult<IAccountGuiModel[]>> {


        const service = new AccountService();
        const result = await service.getAccounts(organizationId, accountType, startRow, pageSize, freeText);

        if (result.hasErrors) {

            return new BusinessLogicResult([], result.errors);

        } else {
            let apiData: IAccountModel[] = result.value;

            let data = apiData.map(e => {
                return {
                    accountId: e.accountId ? e.accountId.toString() : undefined,
                    name: e.name ? e.name : undefined,
                    accountType: e.accountType,
                    bankAccount: e.bankAccount ? e.bankAccount : undefined,
                    businessNumber: e.businessNumber ? e.businessNumber : undefined,
                    vatCode: e.vatCode ? e.vatCode.toString() : undefined,
                }
            });
            return new BusinessLogicResult(data, result.errors);
        }
    };
    public async getAccountsGeneralLedgers(
        organizationId: string,
        startRow?: number,
        pageSize?: number,
        freeText?: string
    ): Promise<BusinessLogicResult<IAccountGuiModel[]>> {


        const service = new AccountService();
        const result = await service.getAccountGeneralLedgers(organizationId, startRow, pageSize, freeText);

        if (result.hasErrors) {

            return new BusinessLogicResult([], result.errors);

        } else {
            let apiData: IAccountModel[] = result.value;

            let data = apiData.map(e => {
                return {
                    accountId: e.accountId ? e.accountId.toString() : undefined,
                    name: e.name ? e.name : undefined,
                    accountType: e.accountType,
                    bankAccount: e.bankAccount ? e.bankAccount : undefined,
                    businessNumber: e.businessNumber ? e.businessNumber : undefined,
                    vatCode: e.vatCode ? e.vatCode.toString() : undefined,
                }
            });
            return new BusinessLogicResult(data, result.errors);
        }
    };
    public async getAccountSuppliers(
        organizationId: string,
        startRow?: number,
        pageSize?: number,
        freeText?: string
    ): Promise<BusinessLogicResult<IAccountGuiModel[]>> {


        const service = new AccountService();
        const result = await service.getAccountSuppliers(organizationId, startRow, pageSize, freeText);

        if (result.hasErrors) {

            return new BusinessLogicResult([], result.errors);

        } else {
            let apiData: IAccountModel[] = result.value;

            let data = apiData.map(e => {
                return {
                    accountId: e.accountId ? e.accountId.toString() : undefined,
                    name: e.name ? e.name : undefined,
                    accountType: e.accountType,
                    bankAccount: e.bankAccount ? e.bankAccount : undefined,
                    businessNumber: e.businessNumber ? e.businessNumber : undefined,
                    vatCode: e.vatCode ? e.vatCode.toString() : undefined,
                }
            });
            return new BusinessLogicResult(data, result.errors);
        }
    };
    public async getAccountCustomers(
        organizationId: string,
        startRow?: number,
        pageSize?: number,
        freeText?: string
    ): Promise<BusinessLogicResult<IAccountGuiModel[]>> {


        const service = new AccountService();
        const result = await service.getAccountCustomers(organizationId, startRow, pageSize, freeText);

        if (result.hasErrors) {

            return new BusinessLogicResult([], result.errors);

        } else {
            let apiData: IAccountModel[] = result.value;

            let data = apiData.map(e => {
                return {
                    accountId: e.accountId ? e.accountId.toString() : undefined,
                    name: e.name ? e.name : undefined,
                    accountType: e.accountType,
                    bankAccount: e.bankAccount ? e.bankAccount : undefined,
                    businessNumber: e.businessNumber ? e.businessNumber : undefined,
                    vatCode: e.vatCode ? e.vatCode.toString() : undefined,
                }
            });
            return new BusinessLogicResult(data, result.errors);
        }
    };
}